import { render, staticRenderFns } from "./VehicleNodes.vue?vue&type=template&id=8edb65b8"
import script from "./VehicleNodes.vue?vue&type=script&lang=js"
export * from "./VehicleNodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports